const translation = {
  title: 'Storage Clusters',
  create: {
    title: 'Create Storage Cluster',
  },
  detail: {
    title: 'Storage Cluster Details',
  },
  edit: {
    title: 'Edit Storage Cluster',
  },
  list: {
    empty_text: 'No Data',
  },
  // Form fields
  form: {
    name: 'Name',
    nameTooltip: 'Unique name for the storage cluster, cannot be changed after creation',
    regionName: 'Region Name',
    regionNameTooltip: 'Region or availability zone where the storage cluster is located',
    type: 'Storage Type',
    typeTooltip: 'Storage cluster type, such as CephFS, local storage, LoongStore, etc.',
    path: 'Cluster Path',
    pathTooltip: 'Cluster path in file system, e.g.: /',
    server: 'Cluster Address',
    serverTooltip: 'Cluster address, e.g.: 123.123.123.123:6789',
    userName: 'User Name',
    userNameTooltip: 'Username for authenticating with the storage cluster',
    userKey: 'User Key',
    userKeyTooltip: 'Secret key for authenticating with the storage cluster, keep it secure',
    apiHost: 'API Address',
    apiHostTooltip: 'API address, e.g.: 123.123.123.123:5000',
    apiUsername: 'API Username',
    apiUsernameTooltip: 'Username for calling storage cluster management API',
    apiPassword: 'API Password',
    apiPasswordTooltip: 'Password for calling storage cluster management API',
    fsId: 'File System ID',
    fsIdTooltip: 'CephFS filesystem unique identifier, can be viewed via ceph fs ls command',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  // Table column headers
  table: {
    id: 'ID',
    regionName: 'Region Name',
    server: 'Server Address',
    userName: 'User Name',
    userKey: 'User Key',
    path: 'Path',
    isDefault: 'Default Cluster',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
  },
  // Action buttons
  actions: {
    create: 'Create Storage Cluster',
    update: 'Update Storage Cluster',
    search: 'Search',
  },
  // Status text
  status: {
    yes: 'Yes',
    no: 'No',
  },
}

export default translation
